import { useLayoutEffect, useRef, useState } from 'react';

/**
 * Caps an element's height to the distance from its top edge to the bottom of
 * the viewport (minus `bottomGap`px). Returns a ref to attach and the computed
 * maxHeight string. Independent of any ancestor flex/height propagation — the
 * only reliable way to make a scroll region when the surrounding layout does
 * not pass a bounded height down.
 */
const useViewportCap = (bottomGap = 48) => {
  const ref = useRef(null);
  const [maxHeight, setMaxHeight] = useState('none');

  useLayoutEffect(() => {
    const measure = () => {
      const el = ref.current;
      if (!el) return;
      const { top } = el.getBoundingClientRect();
      setMaxHeight(`${Math.max(120, window.innerHeight - top - bottomGap)}px`);
    };
    measure();
    // Re-measure after layout settles and on resize.
    const raf = window.requestAnimationFrame(measure);
    window.addEventListener('resize', measure);
    return () => {
      window.cancelAnimationFrame(raf);
      window.removeEventListener('resize', measure);
    };
  });

  return { ref, maxHeight };
};

export default useViewportCap;
